import { api } from '@/api/client'
import type { Partner } from '@/types/models'
import { ListPickerModal } from './ListPickerModal'

interface Props {
  value: number | null
  onChange: (p: Partner) => void
  placeholder?: string
  bizClass?: 'customer' | 'vendor' | 'both' | ''
  /** 지정 시 해당 상위 거래처(그룹)의 자식 거래처만 노출. */
  groupId?: number | null
}

export function PartnerPicker({
  value, onChange, placeholder = '거래처 선택...', bizClass = '', groupId = null,
}: Props) {
  return (
    <ListPickerModal<Partner>
      value={value}
      onChange={onChange}
      title="거래처 선택"
      triggerPlaceholder={placeholder}
      searchPlaceholder="코드, 이름, 사업자번호"
      queryKey={['partners-picker', bizClass, groupId ?? '']}
      fetchDetail={(id) => api<Partner>(`/api/partners/${id}`)}
      fetchList={(q) => {
        const params = new URLSearchParams()
        if (q) params.set('q', q)
        if (bizClass) params.set('biz_class', bizClass)
        if (groupId) params.set('group_id', String(groupId))
        return api<Partner[]>(`/api/partners?${params}`)
      }}
      formatLabel={(p) => `${p.code} ${p.name}`}
      renderRow={(p) => (
        <>
          <span className="font-mono text-xs text-slate-500 tabular-nums mr-2">{p.code}</span>
          <span>{p.name}</span>
        </>
      )}
    />
  )
}
